import cookies from 'js-cookie';
import React, { Fragment, useContext, useEffect } from 'react';
import { Helmet as HeaderMeta } from 'react-helmet';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { LocaleContext } from 'shared';
import { getEnvironmentVar, setSecureCookie } from 'utils';

import { AppProps } from './App.types';
import { DashboardContainer } from './dashboard/DashboardContainer';

export const App = ({ logoutFunction, accountInfo }: AppProps) => {
  const localeContext = useContext(LocaleContext);

  useEffect(() => {
    if (!cookies.get('locale')) {
      setSecureCookie('locale', 'en');
    }
  }, []);

  return (
    <Router basename={getEnvironmentVar('PUBLIC_URL')}>
      <Fragment>
        <HeaderMeta>
          <title>{localeContext.formatMessage({ id: 'GENERAL.TITLE' })}</title>
        </HeaderMeta>

        <Switch>
          {/* tslint:disable jsx-no-lambda */}
          <Route
            path="/"
            render={props => (
              <DashboardContainer {...props} logoutFunction={logoutFunction} accountInfo={accountInfo} />
            )}
          />
          {/* tslint:enable jsx-no-lambda */}
        </Switch>
      </Fragment>
    </Router>
  );
};
